import {
  CANONICAL_PROJECT_ROOM_TABS,
  PROJECT_ROOM_TAB_ALIASES,
  resolveProjectRoomTab,
  type CanonicalProjectRoomTab,
} from "@enrein/shared-contracts";

/** Canonical Step 5 Project Room tabs. */
export const V10_CONTROL_ROOM_SECTIONS = CANONICAL_PROJECT_ROOM_TABS;

export type V10ControlRoomSection = CanonicalProjectRoomTab;

export const V10_SECTION_LABELS: Record<V10ControlRoomSection, string> = {
  overview: "Overview",
  business: "Business",
  website: "Website",
  changes: "Changes",
  "approval-delivery": "Approval & Delivery",
  notes: "Notes",
  activity: "Activity",
  advanced: "Advanced",
};

/** Legacy V10 section aliases → canonical tabs (routing only; no second truth). */
export const V10_SECTION_ALIASES = PROJECT_ROOM_TAB_ALIASES;

export const V10_PROJECT_MODES = [
  "DEFAULT_GENERATION",
  "EXISTING_SITE_SCAN",
  "EXTERNAL_PROOF_ONLY",
] as const;

export type V10ProjectMode = (typeof V10_PROJECT_MODES)[number];

export const V10_MODE_LABELS: Record<V10ProjectMode, string> = {
  DEFAULT_GENERATION: "New Website",
  EXISTING_SITE_SCAN: "Relaunch / Existing Site",
  EXTERNAL_PROOF_ONLY: "External Proof Layer",
};

export function isV10ControlRoomSection(value: string): value is V10ControlRoomSection {
  const resolved = resolveProjectRoomTab(value);
  return (V10_CONTROL_ROOM_SECTIONS as readonly string[]).includes(resolved);
}

export function normalizeV10ControlRoomSection(value: string): V10ControlRoomSection | null {
  const resolved = resolveProjectRoomTab(value);
  return (V10_CONTROL_ROOM_SECTIONS as readonly string[]).includes(resolved)
    ? (resolved as V10ControlRoomSection)
    : null;
}

export function isV10ProjectMode(value: string): value is V10ProjectMode {
  return (V10_PROJECT_MODES as readonly string[]).includes(value);
}
